import Enum from "@utils/enum";

export const INIT_USER_REGISTRATION_DATA = {
  firstName: "",
  lastName: "",
  email: "",
  country: {},
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  agree: false,
  isReceiveEmail: false,
};

export const VERTIFICATION_METHOD_ENUM = Enum({
  EMAIL: "EMAIL",
  SMS: "SMS",
  SUCCESSFUL_VERIFICATION: "SUCCESSFUL_VERIFICATION",
  FAIL_VERIFICATION: "FAIL_VERIFICATION",
});

export const REGISTRATION_PROCCESS_STEPS = {
  step1: 1,
  step2: 2,
};

export const OTP_EXPIRED_TIME = 60;

export const SEND_EMAIL_DISABLED_TIME = 900;
